import React from 'react';
import './LegalPage.css';
import Footer from '../Footer';

const Imprint = () => {
  return (
    <main className="legal-page">
      <div className="legal-page-inner">
        <h1>Impresszum</h1>

        <section className="legal-section">
          <h2>A honlap üzemeltetője</h2>

          <p>
            <strong>Szervezet neve:</strong> Beszédzavarral Élők Jóllétéért (beszÉLJ!) Egyesület
            <br />
            <strong>Nyilvántartási szám:</strong> 07-02-0003490
            <br />
            <strong>Székhely:</strong> 2462 Martonvásár, Petőfi Sándor u. 47.
            <br />
            <strong>Alapítás éve:</strong> 2024
          </p>
        </section>

        <section className="legal-section">
          <h2>Az egyesület céljai</h2>

          <p>
            A Beszédzavarral Élők Jóllétéért (beszÉLJ!) Egyesület célja egy támogató közösség kialakítása és
            fenntartása, amely elősegíti az érintettek egymás közötti
            támogatását (peer support).
          </p>

          <p>
            Az egyesület további célja a társadalmi szemléletformálás,
            valamint az érintettek érdekeinek képviselete és jogvédő
            tevékenység folytatása.
          </p>

          <ul>
            <li>Támogató közösség és peer support</li>
            <li>Társadalmi szemléletformálás</li>
            <li>Jogvédő tevékenység</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>Kapcsolat</h2>

          <p>
            E-mail:{' '}
            <a href="mailto:beszelj@beszeljegyesulet.hu">
              beszelj@beszeljegyesulet.hu
            </a>
          </p>
        </section>

        <section className="legal-section">
          <h2>A honlap</h2>

          <p>
            A honlapon található tartalmak a BeszÉLJ! Egyesület tevékenységének,
            céljainak és programjainak bemutatását szolgálják.
          </p>
        </section>
      </div>
            <Footer />
    </main>
  );
};

export default Imprint;